import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Footer' })({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 80
    },
    promo: {
        maxWidth: '100%'
    }
});
